// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"35842dd9c0a398fcc50b","293":"4239c96fc336cbdb6851","518":"b33e8ffbe2fe40cb85b5","779":"a1343686d03e9dc863f3"}[chunkId] + ".js";
};